<script setup lang="ts">
import useEmblaProgress from '@scripts/composables/use-embla-progress.js'
import emblaCarouselVue from 'embla-carousel-vue'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import Progress from '@components/Progress.vue'

const { showProgress } = defineProps<{
    showProgress?: boolean
}>()

const [emblaRef, emblaApi] = emblaCarouselVue(
    {
        loop: false,
        dragFree: true,
    },
    [WheelGesturesPlugin()]
)

const progress = useEmblaProgress(emblaApi)
</script>

<template>
    <div ref="emblaRef" class="contain-inline-size">
        <div class="flex gap-x-0.5 *:flex-none *:basis-64 2xl:*:basis-80">
            <slot />
        </div>
    </div>
    <Progress
        v-if="showProgress"
        class="mt-8 ml-auto"
        :value="progress"
    />
</template>
